import {ConversationType} from '@toolify/server/src/models/mongoose/MessageModel/enum/ConversationType'
import {
  INewMessageNotificationTypeInterfaces,
} from '@toolify/server/src/services/NotificationService/strategies/INewMessageNotificationTypeInterfaces'
import {i18n} from '@toolify/client/src/setup/i18n'

const {t} = i18n.global

export const GetNewMessageNotificationTitleByConversationTypeMap = new Map<ConversationType,(authorNick: string, payload: INewMessageNotificationTypeInterfaces['payload']) => string>([
  [ConversationType.Workspace, (authorNick: string, payload: INewMessageNotificationTypeInterfaces['payload']) => {
    const typedPayload = payload as INewMessageNotificationTypeInterfaces<ConversationType.Workspace>['payload']
    return t('notifications.browserNotifications.newMessage.workspace', {
      author: authorNick,
      name: typedPayload.conversationNotificationPayload.workspaceConversationName,
    })
  }],
  [ConversationType.CloudFile, (authorNick: string, payload: INewMessageNotificationTypeInterfaces['payload']) => {
    const typedPayload = payload as INewMessageNotificationTypeInterfaces<ConversationType.CloudFile>['payload']
    return t('notifications.browserNotifications.newMessage.cloudFile', {
      author: authorNick,
      name: typedPayload.conversationNotificationPayload.cloudItemName,
    })
  }],
  [ConversationType.DatabaseCell, (authorNick: string, payload: INewMessageNotificationTypeInterfaces['payload']) => {
    const typedPayload = payload as INewMessageNotificationTypeInterfaces<ConversationType.DatabaseCell>['payload']
    return t('notifications.browserNotifications.newMessage.databaseCell', {
      author: authorNick,
      item: typedPayload.conversationNotificationPayload.databaseItemName || t('notifications.browserNotifications.untitledItem'),
      property: typedPayload.conversationNotificationPayload.databasePropertyName,
    })
  }],
  [ConversationType.DatabaseFile, (authorNick: string, payload: INewMessageNotificationTypeInterfaces['payload']) => {
    const typedPayload = payload as INewMessageNotificationTypeInterfaces<ConversationType.DatabaseFile>['payload']
    return t('notifications.browserNotifications.newMessage.databaseFile', {
      author: authorNick,
      file: typedPayload.conversationNotificationPayload.databaseItemFileName,
      item: typedPayload.conversationNotificationPayload.databaseItemName || t('notifications.browserNotifications.untitledItem'),
    })
  }],
  [ConversationType.Direct, (authorNick: string, payload: INewMessageNotificationTypeInterfaces['payload']) => {
    const typedPayload = payload as INewMessageNotificationTypeInterfaces<ConversationType.Direct>['payload']
    const name = typedPayload.conversationNotificationPayload.directConversationName
    return name
      ? t('notifications.browserNotifications.newMessage.direct', {
        author: authorNick,
        name,
      })
      : t('notifications.browserNotifications.newMessage.directNoName', {author: authorNick})
  }],
  [ConversationType.CallRoom, (authorNick: string, payload: INewMessageNotificationTypeInterfaces['payload']) => {
    const typedPayload = payload as INewMessageNotificationTypeInterfaces<ConversationType.CallRoom>['payload']
    return t('notifications.browserNotifications.newMessage.callRoom', {
      author: authorNick,
      name: typedPayload.conversationNotificationPayload.callRoomName || t('notifications.browserNotifications.untitledCall'),
    })
  }],
])
